import styled, { keyframes } from 'styled-components'

import { BREAKPOINTS } from 'resources/constants'
import { heroBg } from 'resources/images'
import { ReactComponent as TitleSvg } from 'resources/images/names.svg'
import { ReactComponent as MonogramSvg } from 'resources/images/monogram.svg'

export const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
	min-height: 100vh;
	background-image: url(${heroBg});
	background-repeat: no-repeat;
	background-size: cover;
	background-attachment: fixed;
	background-position: 65% 25%;
	@media only screen and (min-width: ${BREAKPOINTS.md}) {
		background-position: 65% 35%;
	}
`

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 50px 30px 100px;
	height: 100%;
	width: 100%;
	min-height: 100vh;
`

export const Monogram = styled(MonogramSvg)`
	fill: white;
	max-width: 100%;
	width: 300px;
	height: auto;
	margin-bottom: 20px;
`

export const TitleImage = styled(TitleSvg)`
	fill: white;
	max-width: 100%;
	height: auto;
	width: 500px;
`

export const Title = styled.h1`
	display: none;
`

export const HeroAction = styled.div`
	position: absolute;
	bottom: 30px;
	left: 0;
	width: 100%;
	text-align: center;
`

export const EnterWebsite = styled.button`
	font-size: 12px;
	font-style: italic;
	font-family: 'Trajan Pro', sans-serif;
	line-height: 20px;
	letter-spacing: 0.1em;
	text-align: center;
	text-transform: uppercase;
	text-decoration: none;
	color: white;
	background: none;
	border: none;
	padding: 30px 10px 0;

	&:hover,
	&:focus,
	&:active {
		color: white;
	}
`

const floatAnimation = keyframes`
	0% {
		transform: translate(0, 0);
	}

	50% {
		transform: translate(0, -30px);
	}
`

export const EnterWebsiteContent = styled.span`
	display: block;
	animation: ${floatAnimation} 2s ease-in-out 0s infinite;
`

export const Icon = styled.i`
	display: block;
	margin-top: 5px;
	font-size: 15 px;
	font-style: normal;
`
